<template>
  <div class="f-menu" :style="{ width:store.asideWidth }">
    <el-menu :default-active="defaultActive" unique-opened :collapse="isCollapse" class="border-0" @select="handleSelect" :collapse-transition="false">
      <template v-for="(item, index) in asideMenus" :key="index">
        <el-sub-menu v-if="item.childMenus && item.childMenus.length > 0" :index="item.menuName">
          <template #title>
            <el-icon>
              <component :is="item.menuIcon"></component>
            </el-icon>
            <span>{{ item.menuName }}</span>
          </template>
          <el-menu-item v-for="(item2, index2) in item.childMenus" :key="index2" :index="item2.menuUrl">
            <el-icon>
              <component :is="item2.menuIcon"></component>
            </el-icon>
            {{ item2.menuName }}
          </el-menu-item>
        </el-sub-menu>
        <el-menu-item v-else :index="item.menuUrl">
          <el-icon>
            <component :is="item.menuIcon"></component>
          </el-icon>
          <span>{{ item.menuName }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script setup>

import { useStore } from '~/store'
import { computed, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()
const store = useStore()

const defaultActive = ref(route.path)

const isCollapse = computed(() => !(store.asideWidth == '260px'))
const asideMenus = computed(() => store.menus)

// const asideMenus = [{
//   'menuName': '首页',
//   'menuIcon': 'help',
//   'menuURL': '/'
//   },
//   {
//   'menuName': '文档中心',
//   'menuIcon': 'help',
//   'menuURL': '/documentCenter'
//   },
//   {
//   'menuName': '经销商',
//   'menuIcon': 'shopping-bag',
//   'childMenus': [{
//       'MenuName': '经销商文件管理',
//       'MenuIcon': 'shopping-cart-full',
//       'MenuURL': '/dealerFileManage'
//     }]
//   },
//   {
//   'menuName': '咨询师',
//   'menuIcon': 'shopping-bag',
//   'childMenus': [{
//       'MenuName': '咨询师文件管理',
//       'MenuIcon': 'shopping-cart-full',
//       'MenuURL': '/appraiserFileManage'
//     },
//     {
//       'MenuName': '经销商数据统计',
//       'MenuIcon': 'shopping-cart-full',
//       'MenuURL': '/dealerStatistics'
//     }]
// }]

const handleSelect = (e)=> {
  router.push(e)
}

</script>


<style scoped>
.f-menu {
  transition: all 0.2s;
  top: 64px;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  overflow-x: hidden;
  @apply shadow-md fixed bg-light-50;
}
.f-menu::-webkit-scrollbar {
  width: 0px;
}
</style>
